/**
 * Keys used to store and retrieve basket data from local storage
 */
export const BASKET_STORAGE_KEYS = {
  WEB: {
    id: "ticketbasket",
  },
  WIDGET: {
    id: "ticketbasket.embedded",
  },
};

/**
 * Keys used to store and retrieve the basket id from local storage
 */
export const BASKET_ID_STORAGE_KEYS = {
  WEB: {
    id: "ticketBasketId",
  },
  WIDGET: {
    id: "ticketBasketId",
  },
};

/**
 * Used to communicate with the web-app widget basket
 * Id values are sent via window.parent.postMessage()
 */
export const WIDGET_BASKET_COMMANDS = {
  UPDATE_WIDGET_CART: {
    id: "showpass.shopping-cart.update-basket",
  },
  CLOSE_WIDGET_CART: {
    id: "showpass.shopping-cart.close",
  },
  CHECKOUT_WIDGET_CART: {
    id: "showpass.shopping-cart.checkout",
  },
};
